import { useT } from '../../../../i18n/I18nProvider';
import { PublicShell } from '../../layouts/PublicShell';

export function HomePage() {
  const { t } = useT();

  return (
    <PublicShell>
      <div className="card bg-base-100 shadow-xl w-full max-w-md">
        <div className="card-body items-center text-center gap-4">
          <h1 className="card-title text-3xl">{t('public.home:hero.title')}</h1>
          <p className="text-base-content/70">
            {t('public.home:hero.tagline')}
          </p>
        </div>
      </div>
    </PublicShell>
  );
}
